// Note: The first file of a module here, must also register the module

import "./update-user-dialog.component";
import "./user-autocomplete.component";
import "./user-card-list.component";
import "./user-info.component";
import "./user-list.component";
import "./user-pane.component";
import "./user-stats.component";
import "./user-terms-conditions.component";

import "./seats";
